// Add/Edit surplus-write-off — shared by `declarations` and `incoming-shipments` (SurplusWriteoffModal).
import { baseApi } from '@/lib/api/baseApi';
import { TAG_TYPES } from '@/lib/api/tags';
import { processServerError } from '@/lib/api/listQuery';
import { notifyOnSuccess } from '@/lib/api/notifyOnSuccess';
import { SURPLUS_WRITEOFF_TYPES } from '@/config/surplusWriteoff.constants';

// iscc-backend: PATCH /:module/inbound/update-additional-information/:id (one route, Add and Edit alike).
const surplusWriteoffPath = (module, id) =>
  `/${module}/inbound/update-additional-information/${id}`;

// Inverse of unitSymbol() (lib/mappers/units.js) — the backend's `unit` enum wants the raw member.
const UNIT_ENUM_BY_SYMBOL = Object.freeze({
  'm³': 'CUBIC_METER',
  'm³/15°C': 'CUBIC_METER_15C',
  'Eq.': 'EQUIVALENT',
});

// The backend's BATCH_ADDITIONAL_INFORMATION_TYPE enum is lowercase snake_case, unlike our own vocabulary.
const buildSurplusWriteoffDto = ({ type, quantity, unit }) => ({
  type: type === SURPLUS_WRITEOFF_TYPES.surplus ? 'surplus' : 'write_off',
  quantity,
  unit: UNIT_ENUM_BY_SYMBOL[unit] ?? unit,
});

export const surplusWriteoffApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    updateSurplusWriteoff: build.mutation({
      // buildSurplusWriteoffDto ignores the `shipmentId` a Linked Declarations save also sends.
      query: ({ module, id, ...values }) => ({
        url: surplusWriteoffPath(module, id),
        method: 'PATCH',
        body: buildSurplusWriteoffDto(values),
      }),
      transformErrorResponse: processServerError,
      onQueryStarted: notifyOnSuccess('SURPLUS_WRITEOFF_SAVED'),
      invalidatesTags: (result, error, { id, shipmentId }) => [
        { type: TAG_TYPES.Declaration, id },
        { type: TAG_TYPES.Declaration, id: 'LIST' },
        ...(shipmentId ? [{ type: TAG_TYPES.Shipment, id: shipmentId }] : []),
      ],
    }),
  }),
});

export const { useUpdateSurplusWriteoffMutation } = surplusWriteoffApi;
